import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Dashboard from './dashboard/dashboard';
import Unauthorized from './dashboard/unauthorized';

const renderRoutes = () => {
  return (
    <Switch>
      <Route path={['/login', '/signup', '/account', '/accept-invite', '/auth']} component={Unauthorized} />
      <Route path="/dashboard" component={Dashboard} />
      <Redirect to="/dashboard" />
    </Switch>
  );
};

export default renderRoutes;
